import type { RoleContext } from './roles';

export type AppHomePath = '/kpis' | '/report';

/**
 * Post-login landing route for the app shell (must match `HomePage` redirect logic).
 * All roles share the ComplianceHub Home hub.
 */
export function resolveAppHomePath(_roleContext: RoleContext | null): AppHomePath {
  return '/report';
}

/** Compare route paths for “same page” (trailing slash, hosting quirks). */
export function appPathsAreSame(a: string, b: string): boolean {
  const na = a.length > 1 ? a.replace(/\/+$/, '') : a;
  const nb = b.length > 1 ? b.replace(/\/+$/, '') : b;
  return na === nb;
}
